module.exports = __webpack_public_path__ + "img/background.2dfed511.jpg";